<template>
	<div>
		<van-row style="margin-top: 10px; align-items: center;">
			<van-col span="8">
				<div
					style=" display: flex; justify-content: center; align-items: center; padding: 15px 10px;flex-direction: column;">
					<div>
						<span style="color: rgb(32, 33, 36);fill: rgb(32, 33, 36);stop-color: rgb(32, 33, 36);  font-size: 14px;">{{ favValue }}</span>
						<van-icon name="star" color="#000" />
					</div>
					<span style="font-size: 12px; color: #5f6368; line-height: 20px;">{{ $t('donwload.review') }}</span>

				</div>
			</van-col>
			<div style="height: 24px; border-left: 2px solid #e8eaed;"></div>

			<van-col span="8">

				<div
					style=" display: flex; justify-content: center; align-items: center; padding: 15px 10px 15px 10px;flex-direction: column;">

					<div style="display: flex; flex-direction: row;">
						<span style="color: rgb(32, 33, 36);fill: rgb(32, 33, 36);stop-color: rgb(32, 33, 36);  font-size: 14px;">
							{{ downloads }}
						</span>
					</div>
					<span style="font-size: 12px; color: #5f6368; line-height: 20px;">{{ $t('donwload.donwload')
					}}</span>

				</div>
			</van-col>
			<div style="height: 24px; border-left: 2px solid #e8eaed;"></div>

			<van-col span="7">

				<div
					style=" display: flex; justify-content: center; align-items: center; padding: 15px 10px;flex-direction: column;">
					<img style="height: 15px; width: 15px; object-fit: contain;"
						src="@/assets/download/eighteenPlus.png" />

					<span style="font-size: 12px; color: #5f6368; line-height: 20px;">{{ $t('donwload.rated') }}</span>

				</div>
			</van-col>

		</van-row>
	</div>
</template>
<script setup lang="ts">
import { ref } from 'vue';

const favValue = ref('4,9')
const downloads = ref('50 mil+')

</script>

<style scoped></style>